import { Draft, PayloadAction } from "@reduxjs/toolkit";
import { CurriculumState } from "../../../curriculum-slice";
import dayjs from "dayjs";

export const updateComponentCoverAction = (
  state: Draft<CurriculumState>,
  action: PayloadAction<{
    componentId: number;
    newImage: string;
  }>,
) => {
  const { componentId, newImage } = action.payload;
  const component = state.value.components[componentId];
  if (!component) return;

  state.value.components[componentId] = {
    ...component,
    image: newImage,
    draftExist: true,
    updatedAt: dayjs(),
  };
};
